import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    '& .couriers-container': {
      background: '#E8E8F2',
      borderRadius: 8,
      padding: 12,
      marginBottom: 16,
      '& .request-card': {
        background: Colors.white,
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.08)',
        padding: '12px 8px',
        border: `1px solid ${Colors.grey}`,
        borderRadius: 8,
        marginTop: 8,
        cursor: 'pointer',
      },
    },
    '& .card-head': {
      background: Colors.white,
      padding: 8,
      borderRadius: 8,
      '& .qty': {
        background: 'linear-gradient(270deg, #AF085D 0%, #EA1245 100%)',
        borderRadius: 9,
        height: 18,
        width: 18,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    '& .aside': {
      background: Colors.white,
      borderRadius: 8,
      padding: 16,
      boxShadow: '2px 3px 6px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.02)',
      maxHeight: '100vh',
      boxSizing: 'border-box',
      overflow: 'auto',
    },
  },
};

export default styles;
